import type { LoginFormData } from '..';

const EMPTY_LOGIN: LoginFormData = { email: '', password: '' };

/**
 * The login steps (/login, /verify-mfa, /resend-mfa, /verify-backup-code) are
 * separate routes, and each mounts its own Login, so the form would be lost on
 * every step and the code screens would find no challenge. It lives here
 * between them instead: in memory only, never storage, since it holds the
 * password. Starting over at /login, or signing in, clears it.
 */
let pendingLogin: LoginFormData = EMPTY_LOGIN;

export const getPendingLogin = () => pendingLogin;

export const setPendingLogin = (formData: LoginFormData) => {
  pendingLogin = formData;
  return pendingLogin;
};

export const clearPendingLogin = () => {
  pendingLogin = EMPTY_LOGIN;
};
